<template>
	<div class="my-main">
		<header>
			<div class="header">
				<div :class="'tit '+$i18n.locale">
					<h3>
						<span v-if="$i18n.locale=='en_US'&&title1=='美国整柜直送 - 在线报价'">
							US Container Drayage Delivery Online Quotation
						</span>
						<span v-else>{{ title1 }}</span>
						<span class="tit2" v-if="title1!=='美国整柜直送 - 在线报价'"
						 >{{ title2 }}</span>
						 <span class="tit2" v-if="title1=='美国整柜直送 - 在线报价'&&$i18n.locale=='zh_CN'"
						 >{{ title2 }}</span>
					</h3>

				</div>
				<!-- <div class="time">
					<span class="date">{{ new Date().toLocaleDateString() }}</span>
				</div> -->
			</div>
	
			<!-- <div class="user">
				<div v-if="!islogin" class="login">
					<button @click="login">登录</button>
				</div>
				<el-dropdown v-else placement="bottom">
					<div class="userName">
						<span>{{ getCookie() }}</span>
					</div>
					<template #dropdown>
						<el-dropdown-menu>
							<el-dropdown-item>
								<span @click="logout">退出登录</span>
							</el-dropdown-item>
						</el-dropdown-menu>
					</template>
				</el-dropdown>

			</div> -->
		</header>
		<Register @checkIsLogin="checkIsLogin" ref="myRegister" />
	</div>
</template>
  
<script>
import Register from '@/views/register/index.vue';
export default {
	name: 'my-main',
	components: {
		Register
	},
	data: () => {
		return {
			type: 1,
			title1: "美国整柜直送 - 在线报价",
			title2: "US Container Drayage Delivery Online Quotation",
			islogin: false,
		
		}
	},
	methods: {
		getCookie() {
			return this.$Cookie.get('user_email')
		},


		removeCookie() {
			this.$message({
				message: '退出登录！',
				type: 'success'
			});
			this.$Cookie.set('user_email', '', -1)
		},
		checkIsLogin() {
			if (this.getCookie()) this.islogin = true
			else this.islogin = false
		},
		logout() {
			if (this.getCookie()) { this.removeCookie() }
			this.checkIsLogin()
		},
		login() {
			this.$refs.myRegister.showRegister()

		},
		getCurrentYear() {
			var currentDate = new Date();
			var currentYear = currentDate.getFullYear();
			return currentYear;
		},
		changeHead(val) {
			switch (val) {
				case 'home':
					this.title1 = "美国整柜直送 - 在线报价"
					this.title2 = "US Container Drayage Delivery Online Quotation"
					this.$mitt.emit('changeMenu', 1)
					break;
				case 'DDU&DDP':
					this.title1 = "尾程派送第三方 - 在线报价"
					this.title2 = "US Local Logistics Service Charge  Online Quotation"
					this.$mitt.emit('changeMenu', 2)
					break;
				case 'FBA':
					this.title1 = "尾程派送亚马逊 - 在线报价"
					this.title2 = "US Local Logistics Service Charge  Online Quotation"
					this.$mitt.emit('changeMenu', 3)
					break;
				case 'info':
					this.title1 = "清关/提柜/拆箱"
					this.title2 = "Customs Clearance/Pick Up/Devan"
					this.$mitt.emit('changeMenu', 4)
					break;
				case 'delivery':
					this.title1 = "美国派送距离查询"
					this.title2 = "US Local Address Distance Inquiry"
					this.$mitt.emit('changeMenu', 5)
					break;
				case 'tax':
					this.title1 = `美国${this.getCurrentYear()}关税`
					this.title2 = `U.S. Year${this.getCurrentYear()} Tariff and Tax Inquiry`
					this.$mitt.emit('changeMenu', 6)
					break;
				default:
					break;
			}
		},
	},
	mounted() {
		this.changeHead(this.$route.name)
		this.checkIsLogin()

	},
	watch: {
		$route(to, from) {
			this.changeHead(to.name)
		},
	},
}
</script>
<style scoped>
.lang {
	display: flex;
	align-items: center;
	position: absolute;
	right: 20px;
	top:30%;
}

header {
	background-color: white;
	text-align: center;
	margin-left: 210px;
	position: relative;
}

.user {
	position: absolute;
	right: 45px;
	top: 35%;
}

.userName {
	margin-top: 5px;
	font-size: 14px;
	background: url(@/assets/icon/user.svg) no-repeat left 8px center;
	background-size: 20px;
	background-color: #f4f4fc;
	padding: 7px 15px 7px 35px;
	border-radius: 25px;
	color: #5e5f5f;
	cursor: pointer;
}

.login button {
	background-color: #005bab;
	color: white;
	border: none;
	padding: 7px 35px;
	font-size: 12px;
	border-radius: 25px;
	cursor: pointer;
	transition: 0.5s;
}

.login button:hover {
	transform: scale(0.98);
	opacity: 0.75;
}

.header {
	box-sizing: border-box;
	width: 1000px;
	margin: 0 auto;
	padding: 10px 20px;
	position: relative;
	min-height: 84px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

header .tit {
	width: 420px;
	margin: 0 auto;
}
header .tit.en_US {
	width: 700px;
	margin: 0 auto;
}
header .tit span.en_US{
	display: none;
}

.header h3 {
	color: #6a8dad;
	display: flex;
	background: url(@/assets/img1/cart.svg) no-repeat right center;
	background-size: 70px;
	padding: 10px;
	font-size: 23px;
	flex-direction: column;
	justify-content: center;
}
header .tit.en_US  h3 {
	background-position: 100% 0px;
}

.header h3 span:first-of-type {
	color: #005bab;

}

.header h3 span.tit2 {
	font-size: 12px;
	transform: scale(0.85);
	font-weight: normal;
	color: #aaacb1;
}

.header .time {
	position: absolute;
	right: 0px;
	top: 40%;
	border: 1px solid #d1d6e9;
	font-size: 13px;
	padding: 5px 10px;
	border-radius: 25px;
	font-weight: bold;
}

.header .time .date {
	color: black;
}
</style>

 
 